import type { UseQueryResult } from "@tanstack/react-query";

import { queryKeys } from "../queryKeys";
import {
  type DocumentRequestResponse,
  getAccountDocumentRequests,
} from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAccountDocumentRequests = ({
  accountId,
  options,
}: {
  accountId?: string;
  options?: QueryOptions<DocumentRequestResponse[]>;
}): UseQueryResult<DocumentRequestResponse[]> => {
  return useRequest(
    queryKeys.documents.requests(accountId || ""),
    () => getAccountDocumentRequests(accountId || ""),
    {
      ...options,
    },
  );
};
